<div class="p-3 bg-green color-white">
	<p class="small uc text-center mb-0">Mes mares</p>
</div>

<? if( total ) { ?>
	<div class="py-2 px-3 bb">
		<p class="mb-0 text-center text-secondary small">Vos mares, de la plus récente à la plus ancienne</p>
	</div>
<? } ?>

<div class="pond-list">
	<? _.each( pond_list, function( pond ) { ?>
		<a href="#<?=pond.toUrl('pond/view')?>" class="list-group-item list-group-item-action">
			<div class="d-flex justify-content-between align-items-center">
				<div class="d-flex align-items-center">
					<? /* Vignette small, ou blank si absente */ ?>
					<img src="<?=pond.get('small') || 'img/photo_blank.png'?>" alt="" class="pond-thumb mr-3" width="76" height="76" />
					<div>
						<p class="mb-1">
							<? if( !pond.isNew() ) { ?>
								<span class="badge badge-dark badge-md fw-400">Mare #<?=pond.toFixed('id', 0)?></span>
							<? } else { ?>
								<span class="badge badge-dark badge-md fw-400">Nouvelle mare</span>
							<? } ?>
							<span class="badge badge-<?=pond.getStatus().color?> badge-md fw-400"><?=pond.getStatus().name?></span>
						</p>
						<p class="mb-0">
							<span class="small fw-600"><?=pond.get('city_name') || '—'?></span>
							<br/><span class="small text-secondary">Ajoutée le <?=pond.getDate('created_at')?></span>
						</p>
					</div>
				</div>
				<div><i class="far fa-chevron-right text-secondary"></i></div>
			</div>
		</a>
	<? }) ?>

	<? if( !total ) { ?>
		<em class="list-group-item disabled text-center">
			Aucune mare trouvée
		</em>
	<? } ?>
</div>

<? if( total > page_size ) { ?>
	<div class="p-3 d-flex justify-content-between align-items-center bb bt">
		<? if( has_prev ) { ?>
			<a href="#pond/mine/<?=page - 1?>" class="btn btn-sm btn-outline-secondary">Précédent</a>
		<? } else { ?>
			<span class="btn btn-sm btn-outline-secondary disabled">Précédent</span>
		<? } ?>
		<span class="small text-secondary">Page <?=page?> / <?=page_count?></span>
		<? if( has_next ) { ?>
			<a href="#pond/mine/<?=page + 1?>" class="btn btn-sm btn-outline-secondary">Suivant</a>
		<? } else { ?>
			<span class="btn btn-sm btn-outline-secondary disabled">Suivant</span>
		<? } ?>
	</div>
<? } ?>
